"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const image_1 = __importDefault(require("next/image"));
const prop_types_1 = __importDefault(require("prop-types"));
const next12_utils_environment_1 = require("@gcloud-npm/next12.utils.environment");
// caso de uso
// si detecto movistar.es/estaticos => prod.cms.col.movistar.es/estaticos y no es prod.cms
const MOVISTAR_STATIC_PATH = "movistar.es/estaticos";
const CDN_DOMAIN = "prod.cms.col.movistar.es";
const COL_10_DOMAIN = "https://col10mgmt.tsm.inet";
const PROXY_STATIC_PATH = "https://prod.cms.col.movistar.es/estaticos";
const NEXT_CDN = `${process.env.NEXT_PUBLIC_CDN}`;
const CURRENT_ENVIRONMENT = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
const ERROR_COLOR = "\x1b[31m%s\x1b[0m";
const checkAbsoluteRoute = (src = "") => {
    let res = false;
    if (src && (src.indexOf("http") !== -1 || src.indexOf("//") !== -1)) {
        res = true;
    }
    return res;
};
const customLoader = ({ src /* , width, quality */ }) => {
    const isAbsoluteRoute = checkAbsoluteRoute(src);
    let finalSrc = src;
    const isLocalImage = finalSrc.indexOf("/public") === 0;
    const isMovistarStatic = src.indexOf(CDN_DOMAIN) === -1 && src.indexOf("movistar.es/estaticos") > -1;
    if (isAbsoluteRoute && isMovistarStatic) {
        // quitamos las 3www
        finalSrc = finalSrc.replace("https:", "");
        finalSrc = finalSrc.replace("http:", "");
        finalSrc = finalSrc.replace("//", "");
        finalSrc = finalSrc.replace("www.", "");
        finalSrc = finalSrc.replace(MOVISTAR_STATIC_PATH, PROXY_STATIC_PATH);
    }
    if (!isAbsoluteRoute) {
        if ((CURRENT_ENVIRONMENT === next12_utils_environment_1.ENV_NAME.DEV ||
            CURRENT_ENVIRONMENT === next12_utils_environment_1.ENV_NAME.QA) &&
            !isLocalImage) {
            finalSrc = `${COL_10_DOMAIN}${finalSrc}`;
        }
        if (isLocalImage) {
            finalSrc = `${NEXT_CDN}${finalSrc}`;
            finalSrc = finalSrc.replace("/public", "");
        }
    }
    finalSrc = finalSrc.trim();
    return finalSrc;
};
const ImageN = ({ src, alt, layout, width, height, objectFit, objectPosition, custoObjectInfo, }) => {
    const [imageError, setImageError] = (0, react_1.useState)(false);
    const onError = (e) => {
        if (e && e.currentTarget && e.currentTarget.onerror) {
            e.currentTarget.onerror = null;
        }
        // TODO: Check if a default image will be used to assign a new source
        if (!imageError) {
            setImageError(true);
        }
    };
    if (imageError || !src) {
        console.log(ERROR_COLOR, src);
        return react_1.default.createElement("div", { className: `image fallback ${alt}` });
    }
    let editModal = null;
    let style = {};
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
    }
    return (react_1.default.createElement(image_1.default, { src: customLoader({ src }), alt: alt, width: width, height: height, layout: layout, objectFit: objectFit, objectPosition: objectPosition, unoptimized: true, onError: onError, onClick: editModal }));
};
ImageN.propTypes = {
    src: prop_types_1.default.string.isRequired,
    alt: prop_types_1.default.string.isRequired,
    width: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    height: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    layout: prop_types_1.default.string,
};
ImageN.defaultProps = {
    layout: prop_types_1.default.oneOf(["fixed", "fill", "intrinsic", "responsive", "raw"]),
};
exports.default = ImageN;
//# sourceMappingURL=index.js.map